export default "__VITE_ASSET__B1XXvKp4__ 480w, __VITE_ASSET__DUOb0QoM__ 768w, __VITE_ASSET__CQ4bDHV4__ 1200w, __VITE_ASSET__CWng7gv6__ 1920w";